import React from "react";
const NotFound = () => {
  return <h2>404页面不存在</h2>;
};

export default NotFound;